import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modality"]

  download(event) {
    event.preventDefault()

    const modalitySelect = this.hasModalityTarget
      ? this.modalityTarget
      : this.element.querySelector('[name="q[modality_id_eq]"]')

    if (!modalitySelect || !modalitySelect.value) {
      alert("Please select a Modality filter before downloading certificates.")
      return
    }

    const form = this.element.closest("form") || this.element
    const params = new URLSearchParams(new FormData(form))
    params.delete("commit")
    params.set("format", "zip")

    window.location.href = `${form.action}?${params.toString()}`
  }
}
